import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=60c69f9e&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c69f9e",
  null
  
)

export default component.exports